import { surveyAdminURL, surveyPageURL, surveyRemoveURL } from "../api_urls";
import { createAction, createReducer } from "@reduxjs/toolkit"
import axios from "axios";
import { strings } from "../../utils/localization";

const START_REQUEST = createAction("SURVEY/START_REQUEST")
const FETCH_SUCCESS = createAction("SURVEY/FETCH_SUCCESS")
const REQUEST_SUCCESS = createAction("SURVEY/REQUEST_SUCCESS")
const REQUEST_FAIL = createAction("SURVEY/REQUEST_FAIL")
const ADD_QUESTION = createAction("SURVEY/ADD_QUESTION")
const UPDATE_QUESTION = createAction("SURVEY/UPDATE_QUESTION")
const REMOVE_QUESTION = createAction("SURVEY/REMOVE_QUESTION")
const SET_QUESTIONS = createAction("SURVEY/SET_QUESTIONS")
const CLEAN_MESSAGE = createAction("SURVEY/CLEAN_MESSAGE")
const CHANGE_SIZE = createAction("SURVEY/CHANGE_SIZE")

export const fetchSurveyPage = (perPage, pageNumber) => async (dispatch) => {  
	dispatch(START_REQUEST())
	return axios.get(surveyPageURL(perPage, pageNumber))
	.then(res => handleResponse(res, dispatch, FETCH_SUCCESS, REQUEST_FAIL))
};

export const createSurvey = (payload) => async (dispatch) => {  
	dispatch(START_REQUEST())
	return axios.post(surveyAdminURL, payload)
	.then(res => handleResponse(res, dispatch, REQUEST_SUCCESS, REQUEST_FAIL))
};

export const updateSurvey = (payload) => async (dispatch) => {  
	dispatch(START_REQUEST())
	return axios.put(surveyAdminURL, payload)
	.then(res => handleResponse(res, dispatch, REQUEST_SUCCESS, REQUEST_FAIL))
};

export const removeSurvey = (id) => async (dispatch) => {  
	dispatch(START_REQUEST())
	return axios.delete(surveyRemoveURL(id))
	.then(res => handleResponse(res, dispatch, REQUEST_SUCCESS, REQUEST_FAIL))
};

const handleResponse = (res, dispatch, success, fail) => {
	if(res !== undefined) {
		if(res.status >= 200 && res.status <= 299) {
			if(success === REQUEST_SUCCESS) {
				dispatch(success(res.data.message))
				dispatch(CLEAN_MESSAGE())
			}else{
				dispatch(success(res.data))
			}
			return res
		}else if(res.response !== undefined && res.response.status === 400){
			dispatch(fail(res.response.data.message))
			dispatch(CLEAN_MESSAGE())
		}else{
			dispatch(fail({text: strings.serverErrorMessage, type: "error"}))
			dispatch(CLEAN_MESSAGE())
		}
	}else{
		dispatch(fail({text: strings.serverErrorMessage, type: "error"}))
		dispatch(CLEAN_MESSAGE())
	}
}

export const addNewQuestion = (question) => async (dispatch) => {
	dispatch(ADD_QUESTION(question))
}

export const updateOneQuestion = (payload) => async (dispatch) => {
	dispatch(UPDATE_QUESTION(payload))	
}

export const removeOneQuestion = (index) => async (dispatch) => {
	dispatch(REMOVE_QUESTION(index))	
}

export const setQuestionsArray = (index) => async (dispatch) => {
	dispatch(REMOVE_QUESTION(index))	
}

export const cleanMessage = () => async (dispatch) => {
	dispatch(CLEAN_MESSAGE())
}

export const changeDefaultSize = (size) => async (dispatch) => {
	dispatch(CHANGE_SIZE(size))
}

const initState = {
	data: [],
	pagination: null,
	questions: [],
	defaultSize: 25,
	message: null,
	loading: false,
};

export const surveyReducer = createReducer(initState, (builder) => {
	builder
		.addCase(START_REQUEST, (state, action) => {
			state.loading = true
			state.message = null
		})
		.addCase(FETCH_SUCCESS, (state, action) => {
			state.loading = false
			state.data = action.payload.surveys
			state.pagination = action.payload.pagination
		})
		.addCase(REQUEST_SUCCESS, (state, action) => {
			state.loading = false
			state.message = action.payload
		})
		.addCase(REQUEST_FAIL, (state, action) => {
			state.loading = false
			state.message = action.payload
		})
		.addCase(ADD_QUESTION, (state, action) => {
			state.questions.push(action.payload)
		})
		.addCase(REMOVE_QUESTION, (state, action) => {
			state.questions = state.questions.filter((question, i) => i !== action.payload)
		})
		.addCase(UPDATE_QUESTION, (state, action) => {
			const {index, value} = action.payload;
			state.questions[index].question = value;	
		})
		.addCase(SET_QUESTIONS, (state, action) => {
			state.questions = action.payload
		})
		.addCase(CLEAN_MESSAGE, (state, action) => {
			state.message = null
		})
		.addCase(CHANGE_SIZE, (state, action) => {
			state.defaultSize = action.payload
		})
	})
  